import React, { useState, useEffect } from 'react'
import { connectStore } from 'redux-box'
import { ThemeButton } from '../../../../static/styled/custom.styled'
import './unassign.css'
import { module as ui } from "@st/ui";
import { module as user } from "@st/user";
import Select from 'react-select'

const UnAssignFreadomTeacher = (props) => {
  const [sections, setSections] = useState([])
  const [assignedSections, setAssignedSections] = useState([])

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "relative"
    }),
  };

  useEffect(() => {
    let school_class_list = []
    if (props.user.active_child && props.user.active_child.school_class) {
      const activeClasses = Array.isArray(props.user.active_child.school_class)
        ? props.user.active_child.school_class
        : [props.user.active_child.school_class];

      const teacherId = props.user.active_child.teacher;
      activeClasses.forEach((section) => {
        if (section.teacher === teacherId) {
          school_class_list.push({
            value: section.id,
            label: section.name
          })
        }
      })

      setAssignedSections(school_class_list)
      setSections([])
    }
  }, [props.user.active_child])

  const handleUnAssignTeacher = () => {
    if (sections.length === 0) {
      alert("Please select at least one section")
      return
    }
    const data = {
      is_freadom_teacher: false,
      child: props.user.active_child.id,
      school_class: sections.map((sec) => sec.value),
      class_type: 'FFS'
    }
    props.user.updateFreadomTeacher(data)
    props.ui.hideModal()
  }

  return (
    <div className='unlink_school_code_modal'>
      <p>Are you sure you want to remove the teacher as Freadom Teacher?</p>

      {
        props.user.active_child && props.user.active_child.is_teacher && assignedSections.length > 0 ?
          <div style={{ marginBottom: '15px' }}>
            <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Sections</label>
            <Select
              className="dropdown-container"
              isMulti={true}
              value={sections}
              onChange={(selectedSection) => setSections(selectedSection || [])}
              options={assignedSections && assignedSections}
              placeholder="Select Section"
              styles={customStyles}
            />
          </div>
          :
          <p>No Sections are assigned to teacher.</p>
      }
      <div className='unlink_btn_container'>
        <ThemeButton onClick={() => handleUnAssignTeacher()} primary style={{ width: '50%' }} disabled={assignedSections.length === 0}>Remove</ThemeButton>
        <ThemeButton onClick={() => props.ui.hideModal()} style={{ width: '50%' }}>Cancel</ThemeButton>
      </div>

    </div>
  )
}

export default connectStore({
  ui, user
})(UnAssignFreadomTeacher)
